import { Stack } from "@mui/material";
import { FC } from "react";
import { FloorCard } from "./floor-card";


interface FloorViewerProps {
    floors: number;
    selectedFloor: number;
    setSelectedFloor: (floor: number) => void;
}

const FloorViewer: FC<FloorViewerProps> = ({ floors, selectedFloor, setSelectedFloor }) => {
    return (
        <Stack flexDirection={"column"}>
            <FloorCard key={"all"} onClick={() => setSelectedFloor(0)}
                floorName={"0"} selectedFloor={String(selectedFloor)} />
            {Array.from({ length: floors }, (_, i) => i + 1)?.map(p => (
                <FloorCard key={p} onClick={() => setSelectedFloor(p)}
                    floorName={String(p)} selectedFloor={String(selectedFloor)} />
            ))}
        </Stack>
    )
}

export { FloorViewer };
